import '../style/CardProject.css';

const ProjectCard = () => {
  return(
    // <div className="row">
      <div className="example-2 card">
        <div className="wrapper">
          <div className="header">
            <div className="date">
              <span className="day">on</span>
              <span className="month"> September</span>
              <span className="year"> 2021</span>
            </div>
          </div>
          <div className="data">
            <div className="content">
              <span className="author">Hafid M. | Deddy Gunawan</span>
              <h1 className="title"><a href="/">Bimble.id</a></h1>
              <p className="text">Bimble.id adalah instansi edukasi dan teknologi yang menyediakan layanan lengkap berupa course maupun training  yang materinya dapat disesuaikan dengan  kebutuhan Anda.</p>
              <a href="http://bimble.id" className="button">View site</a>
            </div>
          </div>
        </div>
      </div>
    // </div>
  )
}

export default ProjectCard